import { render, staticRenderFns } from "./ComTabbar.vue?vue&type=template&id=506eafa2&scoped=true&"
import script from "./ComTabbar.vue?vue&type=script&lang=js&"
export * from "./ComTabbar.vue?vue&type=script&lang=js&"
import style0 from "./ComTabbar.vue?vue&type=style&index=0&id=506eafa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506eafa2",
  null
  
)

export default component.exports